var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildlabMeraki(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190.67,
    height: 77,
    viewBox: "0 0 190.67 77",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h143v57.75h-143z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "matrix(-11.427 130.62 -130.62 -11.427 289.28 -35.336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a1d73c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a1d73c",
    offset: 0.16463
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56ba32",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 57.75h143v-57.75h-143z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 77)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h143v57.75h-143z",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.309 23.263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.082 0.036-0.702 0.388-1.623 0.388-1.247 0-2.111-0.826-2.111-1.941 0-1.083 0.826-1.942 2.111-1.942 0.907 0 1.538 0.341 1.623 0.386v-1.956c-0.243-0.064-0.903-0.258-1.758-0.258-2.172 0-4.073 1.422-4.073 3.77 0 2.172 1.722 3.765 4.073 3.765 0.903 0 1.573-0.21 1.758-0.262z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.186 23.263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.078 0.036-0.697 0.388-1.619 0.388-1.25 0-2.114-0.826-2.114-1.941 0-1.083 0.825-1.942 2.114-1.942 0.906 0 1.537 0.341 1.619 0.386v-1.956c-0.24-0.064-0.899-0.258-1.761-0.258-2.167 0-4.065 1.422-4.065 3.77 0 2.172 1.72 3.765 4.065 3.765 0.913 0 1.578-0.21 1.761-0.262z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.37 23.622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.143 0-1.991-0.856-1.991-1.912 0-1.061 0.848-1.916 1.991-1.916 1.144 0 1.995 0.855 1.995 1.916 0 1.056-0.851 1.912-1.995 1.912m4.036-1.912c0-2.082-1.686-3.77-4.036-3.77-2.348 0-4.031 1.688-4.031 3.77 0 2.077 1.683 3.765 4.031 3.765 2.35 0 4.036-1.688 4.036-3.765",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.073 23.693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.026 8e-3 -0.839 0.221-1.506 0.221-0.772 0-1.192-0.245-1.192-0.598 0-0.442 0.565-0.595 0.881-0.693l0.535-0.158c1.25-0.38 1.821-1.197 1.821-2.083 0-1.828-1.689-2.442-3.163-2.442-1.027 0-1.982 0.181-2.081 0.198v1.675c0.171-0.04 0.978-0.271 1.82-0.271 0.957 0 1.401 0.267 1.401 0.683 0 0.367-0.381 0.577-0.862 0.722-0.116 0.036-0.289 0.089-0.413 0.126-1.072 0.324-1.966 0.925-1.966 2.127 0 1.364 1.069 2.275 2.848 2.275 0.937 0 1.821-0.214 1.877-0.229z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.314 33.165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 0.5-0.428 0.908-0.958 0.908-0.522 0-0.954-0.408-0.954-0.908v-1.909c0-0.504 0.432-0.911 0.954-0.911 0.53 0 0.958 0.407 0.958 0.911z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.571 35.673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 0.5-0.428 0.906-0.954 0.906-0.53 0-0.96-0.406-0.96-0.906v-4.416c0-0.505 0.43-0.911 0.96-0.911 0.526 0 0.954 0.406 0.954 0.911z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.827 39.101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 0.504-0.426 0.91-0.955 0.91-0.526 0-0.958-0.406-0.958-0.91v-9.661c0-0.503 0.432-0.912 0.958-0.912 0.529 0 0.955 0.409 0.955 0.912z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.085 35.673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 0.5-0.428 0.906-0.953 0.906-0.53 0-0.958-0.406-0.958-0.906v-4.416c0-0.505 0.428-0.911 0.958-0.911 0.525 0 0.953 0.406 0.953 0.911z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.337 33.165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 0.5-0.425 0.908-0.951 0.908-0.528 0-0.958-0.408-0.958-0.908v-1.909c0-0.504 0.43-0.911 0.958-0.911 0.526 0 0.951 0.407 0.951 0.911z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.598 35.673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 0.5-0.427 0.906-0.955 0.906-0.526 0-0.953-0.406-0.953-0.906v-4.416c0-0.505 0.427-0.911 0.953-0.911 0.528 0 0.955 0.406 0.955 0.911z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.856 39.101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 0.504-0.424 0.91-0.956 0.91-0.522 0-0.953-0.406-0.953-0.91v-9.661c0-0.503 0.431-0.912 0.953-0.912 0.532 0 0.956 0.409 0.956 0.912z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.118 35.673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 0.5-0.43 0.906-0.97 0.906-0.523 0-0.954-0.406-0.954-0.906v-4.416c0-0.505 0.431-0.911 0.954-0.911 0.54 0 0.97 0.406 0.97 0.911z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.366 33.165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 0.5-0.43 0.908-0.956 0.908-0.528 0-0.954-0.408-0.954-0.908v-1.909c0-0.504 0.426-0.911 0.954-0.911 0.526 0 0.956 0.407 0.956 0.911z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m25.765 18.069h-1.931v7.276h1.931z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.414 18.062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-5.959 14.016v-14.016h-1.251v15.597h1.888l6.027-14.298 5.686 14.298h1.82v-15.597h-1.228v13.908l-5.619-13.908z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.783 21.139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.569-2.059-2.389-3.4-4.914-3.4-3.206 0-5.618 2.099-5.618 5.956 0 3.856 2.342 5.956 5.391 5.956 3.026 0 5.346-1.949 5.346-6.239h-9.485c0.114-3.204 2.023-4.678 4.389-4.678 1.775 0 3.139 0.912 3.594 2.405zm-9.257 3.25h8.187c-0.158 2.882-1.865 4.309-4.071 4.309-2.16 0-3.889-1.492-4.116-4.309",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.857 18.062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v11.265h1.001l0.183-2.167c0.636 1.711 1.841 2.491 3.32 2.491 0.477 0 0.954-0.086 1.228-0.174v-1.148c-0.41 0.11-0.819 0.197-1.296 0.197-1.729 0-3.208-1.605-3.208-4.311v-6.153z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.14 26.403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.181 1.926 1.979 3.248 4.595 3.248 2.639 0 4.389-1.407 4.389-3.704v-7.885h-1.001l-0.181 1.862c-0.729-1.167-2.07-2.185-4.185-2.185-2.298 0-3.958 1.189-3.958 3.182 0 1.928 1.228 3.098 4.548 3.618l3.549 0.563v0.975c0 1.625-1.205 2.621-3.229 2.621-1.888 0-3.095-0.929-3.254-2.295zm7.756-4.333v2.102l-3.184-0.52c-2.822-0.455-3.64-1.3-3.64-2.645 0-1.515 1.228-2.273 3.003-2.273 1.888 0 3.821 1.364 3.821 3.336",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.27 18.062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v15.597h1.228v-8.923l5.664 4.591h1.661l-6.075-4.919 6.824-6.346h-1.659l-6.415 5.957v-5.957z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m130.12 33.659h1.479v-1.602h-1.479zm0.112-4.332h1.228v-11.265h-1.228z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildlabMeraki);
export default __webpack_public_path__ + "static/media/buildlab_meraki.4d1ebb6599b57b2679e3cef2a4970b82.svg";
export { ForwardRef as ReactComponent };